import React, { useState } from "react";

const ContactDetails = () => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phonenumber: '',
    message: ''
  });

const [formErrors, setFormErrors] = useState({
    email: '',
  });


const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value
    }));
    // Reset email error when user types in the email field
    if (id === 'email') {
      setFormErrors({
        ...formErrors,
        email: '',
      });
    }
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.firstname) newErrors.firstname = 'First name is required';
  //   if (!formData.lastname) newErrors.lastname = 'Last name is required';
  //   if (!formData.email) newErrors.email = 'Email is required';
  //   if (!formData.message) newErrors.message = 'Message is required';
  //   return newErrors;
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
     // Email validation regex
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email.match(emailPattern)) {
      setFormErrors({
        ...formErrors,
        email: 'Please enter a valid email address',
      });
      return;
    }
    try {
      const response = await fetch('/api/sendEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        alert('Message sent successfully!');
        setFormData({
          firstname: '',
          lastname: '',
          email: '',
          phonenumber: '',
          message: ''
        });
      } else {
        alert('Failed to send message.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      alert('An error occurred while sending the message.');
    }
  };

  return (
    <>
      <div className="single-settings-box profile-details-box top-flashlight light-xl leftside overflow-hidden">
        <div className="profile-details-tab">
          
          <div className="tab-content">
            <div
              className="tab-pane fade active show"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <form
                onSubmit={handleSubmit}
                className="rbt-profile-row rbt-default-form row row--15"
              >
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label htmlFor="firstname">First Name</label>
                    <input id="firstname" type="text" value={formData.firstname} onChange={handleChange} placeholder="First Name"  required/>
                    {/* {errors.firstname && <span className="error">{errors.firstname}</span>} */}
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label htmlFor="lastname">Last Name</label>
                    <input id="lastname" type="text" value={formData.lastname} onChange={handleChange} 
                      placeholder="Last Name"
                    required/>
                    {/* {errors.lastname && <span className="error">{errors.lastname}</span>} */}
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label htmlFor="username">Email</label>
                    <input
                      id="email"
                      type="email"
                      value={formData.email} onChange={handleChange} 
                      className={formErrors.email ? 'p-holder__error' : ''}
                      placeholder="Enter Your Email Here"
                    required
                    />
                    {formErrors.email && <span className="p-holder__error">{formErrors.email}</span>}
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                  <div className="form-group">
                    <label htmlFor="phonenumber">Phone Number</label>
                    <input
                      id="phonenumber"
                      type="tel"
                      value={formData.phonenumber} onChange={handleChange}
                      placeholder="Enter Your Phone No"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="bio">Message</label>
                    <textarea
                      id="message"
                      cols="20"
                      rows="5"
                      value={formData.message} onChange={handleChange}
                      placeholder="Enter Your Message Here"
                    required
                    />
                    {/* {errors.message && <span className="error">{errors.message}</span>} */}
                  </div>
                </div>
                <div className="col-12 mt--20">
                  <div className="form-group mb--0">
                   <button type="submit" className="btn-default">
                    Send Message
                  </button>
                  </div>
                </div>
              </form>
            </div>

            </div>
        </div>
      </div>
    </>
  );
};

export default ContactDetails;
